import { type i18n } from 'i18next';
import { BurgerNavItemProps, NavItemKey } from './BurgerNavDrawer.types';
import { navItems } from './BurgerNavDrawer.constants';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const getNavItemsByOrder = (
  order: NavItemKey[],
  toggleNav: () => void,
  i18n: i18n,
  isDesktop?: boolean
): BurgerNavItemProps[] => {
  return order.map(itemId => {
    const { id, href, translationKey, render } = navItems[itemId];

    if (render) {
      return {
        id,
        ...render(toggleNav, i18n, isDesktop),
      };
    }

    return {
      id,
      href,
      as: CustomLink,
      onClick: toggleNav,
      ...(!isDesktop && { target: '_blank' }),
      children: i18n.t(translationKey || ''),
    };
  });
};
